<template>
    <component
        :is="componentFile"
        :col="col"
        :row="row"
        :items="items"
        :total="total"
        v-bind="customProps"
        v-on="customEvents"
        @get-relation-items="getRelationItems"
        @reload="reloadItems"
    ></component>
</template>

<script>
import components from '@/components/IndexTable/custom/cells/index'

export default {
    name: 'CustomComponentWrapper',

    components,

    props: {
        componentFile: {
            type: String,
            default: () => null,
        },
        col: {
            type: Object,
            default: () => {},
        },
        row: {
            type: Object,
            default: () => {},
        },
        total: {
            type: Number,
            default: () => null,
        },
        items: {
            type: undefined,
            default: () => null,
        },
        customEvents: {
            type: Object,
            default: () => {
                return {
                    noop: () => {
                        // nothing
                    },
                }
            },
        },
        customProps: {
            type: Object,
            default: () => null,
        },
    },

    emits: ['get-items', 'reload'],

    methods: {
        getRelationItems() {
            this.$emit('get-items', this.col, this.row.id)
        },
        reloadItems() {
            this.$emit('reload')
        },
    },
}
</script>
